import './bootstrap';
import './theme';
import './scripts';

// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap'

import Vue from 'vue';

window.Vue = Vue;



Vue.component("GoogleCalendar", require("./components/GoogleCalendar").default);
Vue.component("AggiungiAnagrafica", require("./components/AggiungiAnagrafica").default);
Vue.component("AllegatiFascicolo", require("./components/AllegatiFascicolo").default);
Vue.component("StateFascicolo", require("./components/StateFascicolo").default);

